export default __webpack_public_path__ + "locales/tr/DeleteThirdPartyDialog.json?hash=a8714dfbe23d3f290e015d768f621da8";